import { AllowableKeys, copyWith, Type } from '@client/core/data/concerns/parses-from-json';

/**
 * Instead of creating an object by using its constructor, create an instance of
 * object type T by passing a dictionary (object) of its public properties.
 *
 * All public properties must be specified in the dictionary argument to create
 * an instance of the object.
 *
 * However, public properties that accept an argument are not supported.
 *
 * This is a user-land implementation to support named arguments.
 */
export function make<T>(
  Model: Type<T>,
  values: {
    [k in AllowableKeys<T>]: T[k];
  },
): T {
  const instance = new Model();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return copyWith(instance, values);
}
